import { SocieteDto } from "../dto/GenApi.iNotPaie.Dto/SocieteDto";

export default class JimoHelper {

	/**
	 * Permet d'envoyer à JIMO les attributs relatifs à l'environnement de l'utilisateur.
	 * @param envType
	 * @param isPst
	 */
	static setEnvAttributes(envType: string, isPst: boolean): void {
		window.jimo.push(
			[
				"set",
				"user:attributes",
				[
					{
						'env': envType,
						'estEtudePst': isPst,
						'produit': 'Talent'
					}
				]
			]
		);
	}

	/**
	 * Permet d'envoyer à JIMO les attributs relatifs aux rôles de l'utilisateur.
	 * @param estSalarie
	 * @param estPayeur
	 * @param estUtilisateurPst
	 * @param estAdminPst
	 * @param estAdmin
	 */
	static setUserAttributes(estSalarie: boolean, estPayeur: boolean, estUtilisateurPst: boolean, estAdminPst: boolean, estAdmin: boolean): void {
		window.jimo.push(
			[
				"set",
				"user:attributes",
				[
					{
						'estSalarie': estSalarie,
						'estPayeur': estPayeur,
						'estUtilisateurPst': estUtilisateurPst,
						'estAdminPst': estAdminPst,
						'estAdmin': estAdmin,
					}
				]
			]
		);
	}

	/**
	 * Permet d'envoyer à JIMO les attributds relatifs à la société de l'utilisateur.
	 * @param envType
	 * @param isPst
	 */
	static setSocietettributes(societe: SocieteDto): void {
		window.jimo.push(
			[
				"set",
				"user:attributes",
				[
					{
						'nomEtude': societe.Libelle,
						'crpcen': societe.Crpcen,
						'noIcare': societe.NoIcare
					}
				]
			]
		);
	}
}



// WEBPACK FOOTER //
// ./src/Helper/JimoHelper.ts